module.exports = __webpack_public_path__ + "img/whitetick.ad81c883.svg";